import en from "./en.json";
import it from "./it.json";

const product = { en, it };

export default product;
